import script from "./ContractHistoryBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractHistoryBlock.vue?vue&type=script&setup=true&lang=js"

import "./ContractHistoryBlock.vue?vue&type=style&index=0&id=9f8f628e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8f628e"]])

export default __exports__